<template>
  <div class="cash_reward">
    <span class="cash_reward_text"> {{ companyId === 2 ? '提供本产品利益演示资料，奖励200元' : '提供本产品红利数据，奖励200元' }}</span>
    <span class="cash_reward_btn">
      <span class="cash_reward_btn_look" @click="toPage">立即查看</span>
      <i class="bx-icon bx-icon-close-solid" @click="$emit('close')" />
    </span>
  </div>
</template>

<script >
import { PLANBOOK_PAGE_MAP } from '@/config/assets'
export default {
  props: {
    productItem: {
      type: Object,
      default: null
    }
  },
  computed: {
    companyId() {
      return this.productItem && this.productItem.companyId;
    }
  },
  methods: {
    toPage() {
      location.href = PLANBOOK_PAGE_MAP.dataCollection
    }
  }
}
</script>
<style lang="less">
.cash_reward {
  width: 100vw;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: url('https://media.winbaoxian.com/assets-uploader/cashReward-topBar-1764756836969.png') no-repeat center;
  background-size: 100% 100%;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cash_reward_text {
    font-size: 14px;
    color: #333333;
    line-height: 40px;
  }
  .cash_reward_btn {
    display: flex;
    align-items: center;
    .cash_reward_btn_look {
      font-size: 11px;
      color: #ffffff;
      display: inline-block;
      width: 56px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      background: linear-gradient( 176deg, #FF8800 0%, #FF5000 100%);
      border-radius: 100px;
      margin-right: 15px;
    }
    i {
      font-size: 16px;
      color: #bbbbbb;
    }
  }
}
</style>
